/** Display modifiers from basket → API map: { groupId: optionId | optionId[] } */
export function buildPayloadModifiers(displayModifiers) {
  if (!displayModifiers?.length) {
    return undefined
  }

  const payload = {}
  for (const item of displayModifiers) {
    if (!item.groupId || !item.optionId) {
      continue
    }
    const existing = payload[item.groupId]
    if (existing == null) {
      payload[item.groupId] = item.optionId
      continue
    }
    if (Array.isArray(existing)) {
      existing.push(item.optionId)
      continue
    }
    payload[item.groupId] = [existing, item.optionId]
  }
  return Object.keys(payload).length ? payload : undefined
}
